import { Integrations } from "components/pages/Integrations";
import { IIntegration } from "interfaces/integration.interface";
import { NextSeo } from "next-seo";
import { fetchIntegrations } from "services/contentful";

export default function IntegrationsPage({
  integrations,
}: {
  integrations: IIntegration[];
}) {
  return (
    <>
      <NextSeo title="Integrations" />
      <Integrations integrations={integrations} />
    </>
  );
}

export async function getStaticProps(context) {
  const { data } = await fetchIntegrations();

  return {
    props: {
      integrations: data,
    },
  };
}
